import { defineComponent } from 'vue'
import { BlockModule } from '@/website/blocks/common'
import LoginForm from './components/LoginForm.vue'

new BlockModule({
    selector: '.login-form',
    vueComponent: defineComponent({
        components: {
            LoginForm,
        },
        setup() {},
    }),
})
